export const FETCH_MERCHANT = 'merchantPage/FETCH_MERCHANT';
export const UPDATE_MERCHANT = 'merchant/UPDATE';
